export const serHashPL = [
    "prace-budowlane-i-konstrukcyjne",
    "prace-wykonczeniowe",
    "prace-zewnetrzne-i-drogowe",
    "instalacje-i-systemy",
    "modernizacja-energetyczna",
] ;

export const serTitPL = [
    "Prace Budowlane i Konstrukcyjne",
    "Prace Wykończeniowe",
    "Prace Zewnętrzne i Drogowe",
    "Instalacje i Systemy",
    "Modernizacja Energetyczna",
  ] ;

export const serDescPL = [
    "Od decyzji, poprzez projekt, stan surowy, wykończenie i odbiór",
    "Czuwamy by efekt budowy był zgodny z Państwa projektem w najwyższym standardzie",
    "Przygotowujemy dokumentację i zgłaszamy budynek do odbioru.",
    "Zakładamy sieci komputerowe i systemy ochrony",
    "Instalujemy systemy elektryczne oraz systemy grzewcze",
  ] ;

export const serBulletsPL = [

  [
    "Budowa domów jednorodzinnych",
    "Zabudowa i termoizolacja poddaszy domów jednorodzinnych",
    "Prace ciesielskie, dekarskie, w tym budowa i remont dachów",
    "Tynki tradycyjne i maszynowe, elewacje",
    "Wykonanie fundamentów, ścian nośnych i innych konstrukcji budowlanych",
    "Budowa hal i magazynów",
    "Prace konserwatorskie i renowacyjne obiektów zabytkowych"
  ],
  [
    "Montaż ścianek i sufitów gipsowo-kartonowych",
    "Montaż sufitów podwieszanych listowych i kasetonowych",
    "Malowanie tradycyjne i natryskowe",
    "Tapetowanie, prace przygotowawcze oraz szpachlowanie",
    "Prace glazurnicze, w tym układanie glazury i terakoty",
    "Usługi związane z wykańczaniem wnętrz, takie jak zabudowy meblowe, sufity podwieszane i ścianki działowe",
    "Układanie wykładzin dywanowych, paneli podłogowych kontaktowych, PCV, podłogi drewniane"
  ],
  [
    "Układanie kostki brukowej i chodników",
    "Wykonanie ogrodzeń, bram i furt",
    "Demontaż oraz rozbiórka konstrukcji budowlanych",
    "Wykonywanie prac ziemnych i drogowych, w tym budowa dróg i parkingów"
  ],
  [
    "Instalacje elektryczne",
    "Sieci komputerowe i systemy alarmowe",
    "Instalacje wodnokanalizacyjne oraz instalacje ogrzewania podłogowego",
    "Montaż drzwi i okien, w tym stolarki aluminiowej i PCV",
    "Montaż systemów wentylacyjnych i klimatyzacyjnych"
  ],
  [
    "Prace związane z termomodernizacją budynków",
    "Izolacja termiczna",
    "Montaż okien energooszczędnych",
    "Wykonanie elewacji"
  ]
  
] ;

  